import React, { useEffect, useState } from 'react';
import Data from './Json/Home.json';
import Header from './components/Header/Index';
import Footer from './components/Footer/Index';

const ThankYou = () => {
  const [secondsLeft, setSecondsLeft] = useState(6);

  const lpParam = new URLSearchParams(window.location.search).get('lp');
  const isSscamasa = lpParam === 'sscamasa';
  const targetUrl = isSscamasa
    ? 'https://www.sscamasa.in/'
    : 'https://ssgroup-india.com/';

  useEffect(() => {
    let remaining = 6;
    setSecondsLeft(6);

    const intervalId = setInterval(() => {
      remaining = Math.max(0, remaining - 1);
      setSecondsLeft(remaining);
    }, 1000);

    const timeoutId = setTimeout(() => {
      window.location.href = targetUrl;
    }, 6000);

    return () => {
      clearInterval(intervalId);
      clearTimeout(timeoutId);
    };
  }, [targetUrl]);

  return (
    <>
      <Header Data={Data.header} />
      <div className="flex flex-wrap w-full primary-bg lp-thankyou-page">
        <div className="slideCenter position-center white-space-wrap bg-black-500 p-4 max-width-100">
          <div className="w-full text-center md:w-[520px] m-auto">
            <div className="lp-thankyou-check" aria-hidden="true" />
            <h2 className="text-white text-3xl font-semibold mb-2">Thank You!</h2>
            <p className="text-white mb-4">
              Your request has been received. Our team will call you back shortly.
            </p>

            <p className="text-white">
              Redirecting to homepage in {secondsLeft} seconds...
            </p>

            <div className="lp-thankyou-progress" aria-hidden="true">
              <div className="lp-thankyou-progress-fill" />
            </div>

            <a
              href={targetUrl}
              className="text-white underline mt-4 inline-block"
              target="_blank"
              rel="noopener noreferrer"
            >
              Go to Homepage →
            </a>
          </div>
        </div>
      </div>

      <Footer />
    </>
  );
};

export default ThankYou;
